export default class Filter {
	constructor (filters) {
		this.filters = filters
		this.apiQuery = ''
		this.routerQuery = {}
	}

	get (key, keyValue = null, param = null, _callback = null) {
		const value = this.filters[key]

		if (value === null ||
			value === '' ||
			value.length === 0) return this

		if (typeof _callback === 'function') {
			const filter = _callback({
				filter: this,
				value
			})

			return filter
		}

		if (Array.isArray(value)) {
			if (value.length === 0) return this

			let queryStr

			if (keyValue === null) {
				queryStr = value.join()
			} else {
				queryStr = value.map(item => item[keyValue]).join()
			}

			this.apiQuery += `${param}=${queryStr}`
			param = param.replace(/[^a-zA-Z_]/g, '')
			this.routerQuery[param] = queryStr
		} else {
			this.apiQuery += `${param}=${value}`
			param = param.replace(/[^a-zA-Z_]/g, '')
			this.routerQuery[param] = value
		}

		return this
	}

	init () {
		return {
			apiQuery: this.apiQuery,
			routerQuery: this.routerQuery
		}
	}
}
